import { auth } from "aws-iot-device-sdk-v2"
import { assumeRole, CustomCredentials } from "../services/users-service"
import { CustomAuthoriserData } from "../services/service-utils"

export class TelehealthCredentialProvider implements auth.AwsCredentialsProvider {

    private credentials: CustomCredentials | null = null
    private tryGetStoredSession: () => Promise<string>

    private authData: CustomAuthoriserData | undefined = undefined

    get customAuthData(): CustomAuthoriserData | undefined {
        return this.authData
    }

    constructor(
        tryGetStoredSession: () => Promise<string>,
    ) {
        this.tryGetStoredSession = tryGetStoredSession
    }

    getCredentials(): CustomCredentials | null {
        return this.credentials
    }

    async refreshCredentials() {
        console.log('Refreshing credentials')
        await this.assumeIdentity()
    }

    async assumeIdentity(
        authData?: CustomAuthoriserData
    ): Promise<boolean> {

        const authToken = await this.tryGetStoredSession()

        if (!authToken && !authData?.joinCode) {
            console.log("~~cannot assume identity with no auth")
            return false
        }

        if (authData) {
            this.authData = {
                ...authData,
                authToken,
            }
        } else {
            this.authData = {
                authToken,
                userId: "",
                meetingId: "",
                joinCode: "",
            }
        }

        this.credentials = await assumeRole(this.authData)

        return this.credentials != null
    }
}